const TASK_STATUS_LABELS = {
  ready_for_review: 'Not Reviewed',
  collecting_evidence: 'Collecting Reports',
  in_progress: 'In Progress',
  completed: 'Reviewed',
  expired: 'Expired',
  ignored: 'Dismissed',
}

export const formatTaskStatus = (taskStatus) => {
  return TASK_STATUS_LABELS[taskStatus] ?? 'Invalid Status'
}

const TASK_TYPE_LABELS = {
  qa_dispute: 'Dispute',
  qa_manual_score: 'Pending Evaluation',
  prompt_feedback: 'Prompt Feedback',
}

const TASK_TYPE_AI_LABELS = {
  coaching: { ai: 'AI', manual: 'Manual' },
  compliance: { ai: 'AI', manual: 'Manual Escalation' },
}

export const formatTaskType = (taskType, isAiGenerated) => {
  // Check for types with AI/manual variants
  const aiLabels = TASK_TYPE_AI_LABELS[taskType]
  if (aiLabels) {
    return isAiGenerated ? aiLabels.ai : aiLabels.manual
  }

  // Check for simple type labels
  return TASK_TYPE_LABELS[taskType] ?? 'Invalid Type'
}
